<template>
    <div ref="container" class="flash-container">

        <transition-group tag="div" name="item">
            <div v-for="item in messages"
                 class="item"
                 v-on:click="pinMessage(item)"
                 v-on:mouseenter="focusMessage(item)"
                 v-on:mouseleave="blurMessage(item)"
                 :key="item.id">
                <div class="message" v-bind:class="item.type">
                    <div class="message-title">
                        <div class="message-title-text">
                            {{ item.title }}
                        </div>
                    </div>
                    <div class="message-control" v-on:click="deleteMessage(item)">
                        <icon icon="close" height="16" />
                    </div>
                </div>
            </div>
        </transition-group>

    </div>
</template>
<script>
import { createStore } from "vuex";

export default {
    install(app, options) {
        app.mixin({
            flashMessageStore: createStore({
                modules: {
                    flash: {
                        namespaced: true,
                        actions: {
                            message({ commit }, params) {}
                        }
                    }
                }
            }),
            methods: {
                flashError(title) {
                    this.$options.flashMessageStore.dispatch("flash/message", { title, type: "error" });
                },
                flashInfo(title) {
                    this.$options.flashMessageStore.dispatch("flash/message", { title, type: "info" });
                },
                flashSuccess(title) {
                    this.$options.flashMessageStore.dispatch("flash/message", { title, type: "success" });
                }
            }
        });
    },
    props: ["delay"],
    data() {
        return {
            showDelay: 3000,
            uniqueIndex: 0,
            messages: []
        };
    },
    mounted() {
        this.showDelay = this.$refs.delay ? this.$refs.delay : this.showDelay;

        this.$options.flashMessageStore.subscribeAction((action, state) => {
            if (action.type === "flash/message") {
                this.appendMessage(action.payload.title, { type: action.payload.type });
            }
        });
    },
    methods: {
        deleteMessage(message) {
            this.messages.splice(this.messages.indexOf(message), 1);
        },
        appendMessage(title, options = { type: "error" }) {
            const timeout = setTimeout(() => {
                this.deleteMessage(message);
            }, this.showDelay);

            const message = {
                id: this.uniqueIndex++,
                pinned: false,
                destroying: false,
                type: options.type,
                title,
                timeout
            };

            this.messages.push(message);
        },
        pinMessage(message) {
            message.pinned = true;
            if (message.timeout) {
                clearTimeout(message.timeout);
                message.timeout = false;
            }
        },
        focusMessage(message) {
            for (const i in this.messages) {
                const m = this.messages[i];
                if (m.timeout) {
                    clearTimeout(m.timeout);
                    m.timeout = null;
                }
                if (m === message) {
                    break;
                }
            }
        },
        blurMessage() {
            for (const i in this.messages) {
                const m = this.messages[i];
                if (!m.timeout && !m.pinned) {
                    const timeout = setTimeout(() => {
                        this.deleteMessage(m);
                    }, this.showDelay);
                    m.timeout = timeout;
                }
            }
        }
    }
};
</script>
<style lang="scss">
@import "@tabler/core/scss/variables";
$border-radius: 4px;

.flash-container {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    max-width: 320px;
    overflow: auto;
    box-sizing: border-box;
    z-index: 2000;
    max-height: 100%;

    > div > .item {
        width: 100%;
        overflow: hidden;
        clear: both;
        max-height: 100px;

        > .message {
            background: rgba(0, 0, 0, 0.88);
            border-radius: $border-radius;
            color: #fff;
            margin: 4px 4px 0 4px;
            display: flex;

            > .message-title {
                flex-grow: 1;

                .message-title-text {
                    padding: 15px;
                }
            }

            > .message-control {
                cursor: pointer;

                > .icon {
                    margin: 8px;
                }
            }

            &.success {
                background: transparentize($green, 0.04);
                color: $white;

                svg {
                    fill: $white;
                }
            }

            &.error {
                background: transparentize($red, 0.04);
                color: $white;

                svg {
                    fill: $white;
                }
            }

            &.info {
                background: transparentize($blue, 0.04);
                color: $white;

                svg {
                    fill: $white;
                }
            }
        }

        &.item-enter-active,
        &.item-leave-active,
        &.item-move {
            transition: 500ms cubic-bezier(0.6, 0.15, 0.35, 0.95);
            transition-property: max-height, opacity;
        }

        &.item-enter {
            opacity: 0;
        }

        &.item-enter-to {
            opacity: 1;
        }

        &.item-leave-to {
            max-height: 0;
            opacity: 0;
        }
    }
}
</style>
